import * as React from "react";
import { CustomerNotification, CustomerNotificationLocation } from "@shared-ui/customer-notifications";
import { PageStore } from "bernie-core";
import { inject } from "mobx-react";
import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";
import { isVariantEnabled, Experiment } from "src/components/utility/experiment";

interface TravelAdvisoryProps {
  context: ExtendedContextStore;
  page?: PageStore;
}

export const TravelAdvisory: React.FC<TravelAdvisoryProps> = inject("page")((props: TravelAdvisoryProps) => {
  const { context, page } = props;
  const isTravelAdvisoryExperimentEnabled = isVariantEnabled(
    context,
    Experiment.LP_SC_Covid19_TravelAdvisory_for_LandingPages
  );

  if (!page || !page.pageId || !context || !isTravelAdvisoryExperimentEnabled) {
    return null;
  }

  const regionId = context.searchContext?.location?.id?.toString() || "";

  return (
    <div className="travelAdvisoryBanner uitk-cell all-cell-1-1 all-y-padding-three">
      <CustomerNotification
        inputs={{
          xPageId: page.pageId,
          notificationLocation: CustomerNotificationLocation.AFTER_HEADER,
          optionalContext: {
            regionIds: [regionId],
          },
        }}
      />
    </div>
  );
});

export default TravelAdvisory;
